import { useApolloClient } from '@apollo/client';

var useMutationQuery = function useMutationQuery() {
  var client = useApolloClient();
  return client.mutate;
};

export { useMutationQuery as u };
